import { withNamespaces } from "react-i18next";
import Accordion from 'react-bootstrap/Accordion';
import { Table, UncontrolledTooltip } from "reactstrap";
import { RiInformationLine, RiShieldCrossLine } from "react-icons/ri";
import DateUtils from "src/services/utils/DateUtils";
import { INTERNATIONAL_DATE_FORMAT } from 'src/common/constants';

const RiskScore = ({
    t,
    setActiveAccordion,
    activeAccordion,
    detailsQuery
}) => {
    const organizationData = JSON.parse(detailsQuery.data?.company?.organizationData || "");

    const dateUtils = new DateUtils();

    const {
        failure_score = []
    } = organizationData || {};

    return (
        <Accordion.Item 
            onClick={() => setActiveAccordion('risk-score')}
            className={activeAccordion === 'risk-score' ? 'active' : ''}
            eventKey={'risk-score'}
        >
            <Accordion.Header>
                <RiShieldCrossLine size="24" className="me-2" />
                <span>
                    {t('Risk & Failure Score')}
                </span>
            </Accordion.Header>

            <Accordion.Body>
                <Table striped bordered hover size="sm">
                    <thead>
                        <tr>
                            <th>{t('Score Date')}</th>
                            <th>
                                {t('Algorithm ID')}
                                <span
                                    id="tooltip-failure_score_algorithm"
                                    className="ms-1"
                                    style={{ cursor: "pointer" }}>
                                    <RiInformationLine />
                                </span>
                                <UncontrolledTooltip
                                    target="tooltip-failure_score_algorithm"
                                >
                                    {t('Identifies the model used to calculate the score.')}
                                </UncontrolledTooltip>
                            </th>
                            <th>
                                {t('Score')}
                                <span
                                    id="tooltip-failure_score"
                                    className="ms-1"
                                    style={{ cursor: "pointer" }}>
                                    <RiInformationLine />
                                </span>
                                <UncontrolledTooltip
                                    target="tooltip-failure_score"
                                >
                                    {t('The Credit (Delinquency) Score is a statistically modeled D&B Score indicating the risk of delinquent payments based on the information in D&B’s file. The higher the Credit (Delinquency) Score, the lower the probability of payment delinquency.')}
                                </UncontrolledTooltip>
                            </th>
                            <th>
                                {t('National Percentile')}
                                <span
                                    id="tooltip-national_percentile"
                                    className="ms-1"
                                    style={{ cursor: "pointer" }}>
                                    <RiInformationLine />
                                </span>
                                <UncontrolledTooltip
                                    target="tooltip-national_percentile"
                                >
                                    {t('The Credit (Delinquency) Score Percentile illustrates where a company falls among businesses in the D&B information base, and is most effectively used by customers to rank order their portfolios from highest to lowest risk of delinquency. The Percentile is based on a 1 – 100 scale, where a 1 represents businesses that have the highest probability of severe delinquency, and a 100 which represents businesses with the lowest probability of severe delinquency.')}
                                </UncontrolledTooltip>
                            </th>
                            <th>
                                {t('Commentaries')}
                                <span
                                    id="tooltip-score_commentaries"
                                    className="ms-1"
                                    style={{ cursor: "pointer" }}>
                                    <RiInformationLine />
                                </span>
                                <UncontrolledTooltip
                                    target="tooltip-score_commentaries"
                                >
                                    {t('The Credit (Delinquency) Score Commentary field is a repeating field containing codes which explain the conditions driving the score assigned to the business.')}
                                </UncontrolledTooltip>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {failure_score.map((fs, idx) => (
                            <tr key={idx}>
                                <td>
                                    {dateUtils.convertDateToDate(
                                        fs.score_date, 
                                        INTERNATIONAL_DATE_FORMAT
                                    )}
                                </td>
                                <td>{fs.algorithm_id}</td>
                                <td>{fs.score}</td>
                                <td>{fs.national_percentile}</td>
                                <td>
                                    <ul>
                                        {fs.score_commentaries.map((c, i) => (
                                            <li key={i}>{c.description || c.code}</li>
                                        ))}
                                    </ul>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </Accordion.Body>
        </Accordion.Item>
    )
}

export default withNamespaces()(
    RiskScore
);